import { isNil } from '@/utilities/fp';
import type { TimeSeriesItem } from '../../../../hooks/useCompanyTimeSeries';

export const getFreeCashFlowDifference = (
  earnings: number | null,
  depAndAmort: number | null,
  stockBasedComp: number | null,
  netWorkingCapital: number | null,
  freeCashFlow: number | null
) => {
  if (
    isNil(earnings) ||
    isNil(depAndAmort) ||
    isNil(stockBasedComp) ||
    isNil(netWorkingCapital) ||
    isNil(freeCashFlow)
  ) {
    return null;
  }

  const increments =
    earnings + depAndAmort + stockBasedComp + netWorkingCapital;

  return freeCashFlow - increments;
};

export const isSufficientData = (timeSeries: TimeSeriesItem[] | null) => {
  return timeSeries !== null && timeSeries.length > 0;
};

export const getValidTimeSeries = (
  timeSeries: TimeSeriesItem[] | null | undefined
) => {
  return (
    timeSeries?.filter(
      (item) =>
        item.changeNetWorkingCapital !== null &&
        item.depreciationAmortizationTotal !== null
    ) ?? []
  );
};

export const getLatestReportedDate = (
  timeSeries: TimeSeriesItem[] | null | undefined
) => {
  if (timeSeries?.length && timeSeries.length > 0)
    return timeSeries[timeSeries.length - 1].date;
  return '';
};
